// Extracts a URL parameter and converts it to an integer
const getUrlParams = (url, param) => {
    const searchUrl = new URL(url);
    const searchParams = new URLSearchParams(searchUrl.search);
    if (searchParams.has(param)) {
        return searchParams.get(param);
    }

    return null;
};

export default getUrlParams;
